import { Button } from '@mantine/core';
import { useToggle } from '@mantine/hooks';
import { ReactQueryDevtoolsPanel } from '@tanstack/react-query-devtools';
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools';
import cx from 'clsx';
import { use } from 'react';

import classes from './Devtools.module.css';
import { ProjectContext } from '#contexts/ProjectContext';

export function Devtools() {
  const { config } = use(ProjectContext);
  const [isDevtoolsVisible, toggleDevtools] = useToggle([null, 'query', 'router'] as const);

  if (!config.debug.devtools.enabled) {
    return null;
  }

  return (
    <div className={classes.devtools}>
      <nav className={classes.devtoolsNav}>
        <Button onClick={() => toggleDevtools(isDevtoolsVisible === 'query' ? null : 'query')} size="xs">
          Query Devtools
        </Button>
        <Button onClick={() => toggleDevtools(isDevtoolsVisible === 'router' ? null : 'router')} size="xs">
          Router Devtools
        </Button>
      </nav>
      <div className={classes.devtoolsPanel}>
        <div className={cx(classes.devtoolsInstance, isDevtoolsVisible === 'query' && classes.devtoolsInstanceEnabled)}>
          <ReactQueryDevtoolsPanel />
        </div>
        <div
          className={cx(classes.devtoolsInstance, isDevtoolsVisible === 'router' && classes.devtoolsInstanceEnabled)}
        >
          <TanStackRouterDevtoolsPanel />
        </div>
      </div>
    </div>
  );
}
